import { Images } from 'lucide-react';
import { Link } from 'react-router-dom';

const MemoryEmptyState = () => (
  <div className="flex flex-col items-center px-6 py-16 text-center">
    <div className="mb-4 flex h-[72px] w-[72px] items-center justify-center rounded-3xl bg-brand-50 dark:bg-brand-500/15">
      <Images size={32} className="text-brand-500" strokeWidth={1.5} />
    </div>
    <h3 className="text-base font-bold text-surface-900 dark:text-white">No memories yet.</h3>
    <p className="mt-2 max-w-xs text-sm leading-relaxed text-surface-500 dark:text-[#B5BDD1]">
      Join activities and start creating memories.
    </p>
    <Link to="/feed" className="btn-primary mt-6 !px-5 !py-2.5 !text-sm">
      Explore Activities
    </Link>
  </div>
);

export default MemoryEmptyState;
